import React from 'react'
import H1 from '../../components/H1'
import '../../styles/css/services.css'

const section = {
  target: 'services',
  title: 'Services'
}

const Services = () => (
  <div className="services">
    <div className="services-location">
      <H1 section={section} />
    </div>
    <div className="services-content">
    <div className="services-hero">
      <div className="col">
        <h1 className="video-services">Video Services</h1>
        <ul>
              <li>HD and Ultra HD Broadcast</li>
              <li>Commercials</li>
              <li>Documentaries</li>
              <li>Motion Pictures</li>
              <li>Interviews</li>
              <li>Music Videos</li>
              <li>Multi Camera Productions</li>
              <li>Special Events</li>
              <li>Live Action</li>
          </ul>
      </div>

      <div className="col">
        <h1 className="photo-services">Photo Services</h1>
        <ul>
          <li>Beauty</li> 
          <li>Fashion</li> 
          <li>Runway</li> 
          <li>Head Shots</li> 
          <li>Branding</li> 
          <li>Lifestyle</li> 
          <li>Red Carpet</li> 
          <li>Sports</li> 
          <li>Special Events</li> 
        </ul>
      </div>

      <div className="col">
        <h1 className="music-services">Music Services</h1>
        <ul>
          <li>Music Production</li>
          <li>Song Writing</li>
          <li>Motion Picture Scores</li>
          <li>Sound Engineering</li>
          <li>Sound Recording</li>
          <li>Mixing and Mastering</li> 
          <li>Voice Overs</li>
        </ul>
      </div>
      </div>
    </div>
  </div>
)

export default Services



// WEBPACK FOOTER //
// ./src/containers/home/services.js